import { render, staticRenderFns } from "./ClothInfo.vue?vue&type=template&id=29bca65a&scoped=true"
import script from "./ClothInfo.vue?vue&type=script&lang=js"
export * from "./ClothInfo.vue?vue&type=script&lang=js"
import style0 from "./ClothInfo.vue?vue&type=style&index=0&id=29bca65a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bca65a",
  null
  
)

export default component.exports